import React from "react";
import { useParams } from "react-router";
import { buildingSettingsStore } from "store/Building/BuildingSettingsStore";
import { buildingStore } from "store/Building/BuildingStore";
import { dynamicMEStore } from "store/Mapping/DMEStore";
import { organisationStore } from "store/OrganisationStore";

export function useBuildings() {
  const { currentBuilding } = buildingStore;
  const { id: buildingID } = useParams();

  React.useEffect(() => {
    buildingStore.setBuildingID(buildingID);
  }, [buildingID]);

  React.useEffect(() => {
    dynamicMEStore.fetchCertificationData();
  }, []);

  React.useEffect(() => {
    if (!buildingSettingsStore.buildingAlreadyUpdated) return;
    const timer = setTimeout(() => {
      buildingSettingsStore.setBuildingAlreadyUpdated(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, [buildingSettingsStore.buildingAlreadyUpdated]);

  async function refreshOnChangeBuilding() {
    if (!currentBuilding) return;
    if (organisationStore.organisations.length === 0) {
      await organisationStore.getAllOrganisations();
    }
    const currentOrg = organisationStore.organisations.find(
      (item) => item.id === currentBuilding?.organisation_id
    );
    organisationStore.setCurrentOrganisation(currentOrg);
    !buildingStore.sourceFiles.loading &&
      buildingStore.setSourceFiles({
        ...buildingStore.sourceFiles,
        loading: true,
      });
    buildingStore.resetBuildingMappingStatus();
    await buildingStore.getAllSourceFiles();
    await buildingStore.getBuildingMappingStatus();
  }

  return {
    refreshOnChangeBuilding,
  };
}
